import { createContext, useContext } from 'react';

const CardLayoutContext = createContext(null);

export const useCardLayout = () => useContext(CardLayoutContext);

export const CardLayoutProvider = CardLayoutContext.Provider;
